import React, { useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Stack,
  Divider,
  Button,
} from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DescriptionIcon from "@mui/icons-material/Description";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { useLocation, useNavigate } from "react-router-dom";
import Menus from "../../Components/Menu/Menu";
import IconButtonField from "../../Components/Button/IconButtonField";
import styles from "../Mockexampage/MockGrid.module.scss";
import Avatars from "../../Components/Avatar/Avatars";
import { listSubjectNote } from "../../Redux/Slices/StudyNote/SubjectStudyNode";
import Mockexamimage from "../Mockexampage/Imagemockexampage/MockExamimage.jpg";
import { listListSubjectNoteTopicSlice } from "../../Redux/Slices/StudyNote/TopicStudyNode";
import { listListSubjectNoteSubTopicSlice } from "../../Redux/Slices/StudyNote/TopicSubStudyNode";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import UserProfileSection from "../../Components/UserProfileSection/UserProfileSection";

const Topic = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { state: topicid } = useLocation();
  useEffect(() => {
    dispatch(listUser());
    dispatch(listListSubjectNoteTopicSlice({ sub_id: topicid }));
  }, [dispatch, topicid]);
  const { data: ListSubjectNoteTopic } = useAppSelector(
    (state) => state.ListSubjectNoteTopicSlice
  );
  const Subjecttopic: any = ListSubjectNoteTopic?.data;

  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );

  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];

  return (
    <div className="ExamprocessStudentAlingment">
      <Box sx={{ mb: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ textTransform: "none", color: "#666" }}
        >
          Back
        </Button>
      </Box>
      <Grid container spacing={3}>
        {Subjecttopic?.length > 0 ? (
          Subjecttopic?.map((item: any, index: number) => (
            <Grid item xs={12} sm={12} md={6} lg={3} key={index}>
              <Card
                onClick={() => {
                  dispatch(
                    listListSubjectNoteSubTopicSlice({ topic_id: item?.id })
                  );
                  navigate("/subtopic", { state: item?.id }); // Replace with your target route
                }}
                sx={{
                  height: "100%",
                  cursor: "pointer",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  transition: "transform 0.2s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-4px)",
                  },
                }}
              >
                {/* Top Image */}
                <Box sx={{ position: "relative" }}>
                  <img
                    src={item.image}
                    alt={item.name}
                    style={{
                      width: "100%",
                      height: "180px",
                      objectFit: "cover",
                    }}
                  />
                </Box>

                {/* Content */}
                <CardContent
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Typography
                      variant="h6"
                      fontWeight="600"
                      fontSize={"18px"}
                      gutterBottom
                      sx={{
                        color: "text.primary",
                        cursor: "pointer",
                        "&:hover": {
                          color: "#009DFF", // or use theme color: "primary.main"
                        },
                      }}
                    >
                      {item.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 2, color: "#6b7280", fontSize: "15px" }}
                      className="studynote-card-description"
                    >
                      {item.description}
                    </Typography>
                  </div>
                  <div>
                    {/* Topics and Examples */}
                    <Stack
                      direction="row"
                      spacing={3}
                      alignItems="center"
                      sx={{ justifyContent: "space-between" }}
                    >
                      <Stack direction="row" spacing={0.5} alignItems="center">
                        <MenuBookIcon
                          fontSize="small"
                          sx={{ color: "#6b7280", fontSize: "15px" }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: "#6b7280", fontSize: "15px" }}
                        >
                          {item.subtype_count}{" "}
                          {item.subtype_count > 1 ? "topics" : "topic"}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5} alignItems="center">
                        <DescriptionIcon
                          fontSize="small"
                          sx={{ color: "#6b7280", fontSize: "15px" }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: "#6b7280", fontSize: "15px" }}
                        >
                          {item.example_count}
                          {item.example_count > 1 ? "examples" : "example"}
                        </Typography>
                      </Stack>
                    </Stack>

                    {/* Study Time */}
                    <Box sx={{ mt: 2 }}>
                      <Stack direction="row" spacing={0.5} alignItems="center">
                        <Typography
                          variant="body2"
                          fontWeight="bold"
                          sx={{
                            backgroundColor: "#F1F5F9",
                            px: 1,
                            py: 0.5,
                            borderRadius: 1,
                            fontSize: "12px",
                            display: "flex",
                            gap: "6px",
                          }}
                        >
                          <AccessTimeIcon fontSize="small" />
                          {item.total_timing}
                        </Typography>
                      </Stack>
                    </Box>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <Card className={styles.card} sx={{ boxShadow: "none" }}>
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={Mockexamimage}
                  alt="Mock Exam"
                  style={{
                    width: "100%",
                    height: "97%",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                />
              </div>

              <CardContent className={styles.cardBody}>
                <div className={styles.mockexamname}> No Topic Available</div>
                <Typography
                  variant="body2"
                  className={styles.mockexamndescription}
                >
                  Currently, there are no mock exams available at the moment.
                  Please check back soon for updates and new mock exams
                </Typography>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="contained"
                    className={styles.startButton}
                    onClick={() => {
                      navigate("/dashboard");
                    }}
                  >
                    Back to home
                  </Button>
                </div>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default Topic;
